<template>
  <div v-loading="$wait.waiting(_uid)" class="card list-groups">
    <div class="card-content">
      <acl :permissions="['companies_groups_create']">
        <div class="text-right control-button-wrapper pt-xxs">
          <acl :permissions="['companies_groups_create']">
            <router-link :to="{ name: 'companies_groups@create' }">
              <button
                class="btn btn-info btn-fill btn-wd submit-button"
                :class="{ loading: $wait.waiting(_uid) }"
              >
                New
                <i
                  v-show="$wait.waiting(_uid)"
                  class="fas fa-circle-notch loading-icon"
                />
              </button>
            </router-link>
          </acl>
        </div>
      </acl>

      <div class="mt-s">
        <div class="mb-5 w-full">
          <fieldset>
            <div class="form-group">
              <input
                v-model="searchQuery"
                type="search"
                class="form-control form-search"
                placeholder="Type to find what you are looking for"
                aria-controls="datatables"
                autofocus
              />
            </div>
          </fieldset>
        </div>

        <div>
          <el-table
            class="table-striped"
            :data="queriedData"
            :default-sort="defaultSort"
            border
            style="width: 100%"
          >
            <el-table-column
              sortable
              :sort-orders="['ascending', 'descending']"
              min-width="250"
              prop="name"
              label="Name"
            >
              <template #default="scope">
                <router-link
                  :to="{
                    name: 'companies_groups@show',
                    params: { id: scope.row.id },
                  }"
                >
                  {{ scope.row.name }}
                </router-link>
              </template>
            </el-table-column>

            <el-table-column
              sortable
              :sort-orders="['ascending', 'descending']"
              min-width="250"
              prop="managers"
              label="Managers"
            >
              <template #default="scope">
                <span
                  v-for="(manager, index) in scope.row.managers"
                  :key="manager.id"
                >
                  <router-link
                    :to="{
                      name: 'companies_users@show',
                      params: { id: manager.id },
                    }"
                    >{{ manager.fullName }}</router-link
                  >
                  <span v-if="index != scope.row.managers.length - 1">, </span>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- <div class="flex justify-between items-center">
          <div>
            <p class="category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>

          <p-pagination
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
          />

          <div>
            <el-select
              v-model="pagination.perPage"
              class="select-default"
              placeholder="Per page"
            >
              <el-option
                v-for="item in pagination.perPageOptions"
                :key="item"
                class="select-default"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Table, TableColumn } from "element-ui";
//import PPagination from "@components/UIComponents/Pagination.vue";
import tableConfig from "@providers/table";
import { mapGetters, mapState, mapActions } from "vuex";

Vue.use(Table);
Vue.use(TableColumn);

export default {
  components: {
    //PPagination,
  },
  data() {
    return {
      ...tableConfig.data,
      defaultSort: { prop: "name", order: "ascending" },
    };
  },
  computed: {
    ...mapState("companyGroupStore", ["groups"]),
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    tableData() {
      return this.groups;
    },
    ...tableConfig.computed,
  },
  async mounted() {
    try {
      this.$wait.start(this._uid);
      await this.getCompanyGroups();
    } catch (error) {
      this.addNewError(error);
    } finally {
      this.$wait.end(this._uid);
    }
  },
  methods: {
    ...mapActions("loadingStore", ["setLoading"]),
    ...mapActions("companyGroupStore", ["getCompanyGroups"]),
    ...mapActions("errorStore", ["addNewError"]),
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/tables";
@import "@/assets/sass/paper/variables";
.list-groups td {
  position: relative;
  z-index: 1;

  .cell {
    color: $info-color;
    font-weight: 600;
    cursor: pointer;
    display: inline;
  }
}
</style>
